import swaggerClient from '../../utility/swaggerClient';




export const dataFactoryList = async (customerId) => {
  const params = {customerId};
  const client = await swaggerClient();
  const response = (await client.apis.dataFactoryList.get_project_datafactorylist__customerId_(
    {
      ...params
    }
  )).body;
  return response;

};

export const dataFactoryTable = async (dataFactory) => {
  const params = {dataFactory};
  const client = await swaggerClient();
  
  const response = (await client.apis.datafactorytable.get_project_datafactorytable__dataFactory_(
  {
    ...params
  }
)).body;
  return response;
};

export const findByProjectName = async (projectName) => {
  const params = {projectName};
  const client = await swaggerClient();

  const response = (await client.apis.findByProjectName.get_project_findByProjectName__projectName_(
    {
      ...params
    })).body;
    return response;
};

export const translateFiles = async (projectId, fileList) => {
  const client = await swaggerClient();
  // console.log(projectId, files);
  // console.log(client.apis.translate.post_translate);

  const response = (await client.apis.translate.post_translate({
    files: {
      projectId,
      fileList
    }
  })).body;

  return response;
};

export const previewFile = async (projectId, fileId) => {
  const client = await swaggerClient();
  const response = (await client.apis.file.get_project__projectId__file__fileId_(
    {
      projectId,
      fileId,
      view: 'source'
    }
  )).body.source;

  return response;
};

export const reviewFile = async (projectId, fileId) => {
  const params = { projectId, fileId };
  const client = await swaggerClient();

  const src = (await client.apis.file.get_project__projectId__file__fileId_({
    ...params,
    view: 'source'
  })).body.source;

  const tgt = (await client.apis.file.get_project__projectId__file__fileId_({
    ...params,
    view: 'target'
  })).body.target;

  const disc = (await client.apis.file.get_project__projectId__file__fileId_({
    ...params,
    view: 'discrepancy'
  })).body.discrepancy;

  // const rpt = (await client.apis.file.get_project__projectId__file__fileId_({
  //   ...params,
  //   view: 'report'
  // })).body.report;

  const rpt = (await client.apis.report.get_report__projectId___fileId_({
    ...params
  })).body.reportContent;

  return { src, tgt, disc, rpt };
};

export const viewReport = async (reportId, fileId) => {
  const client = await swaggerClient();
  //console.log(client.apis.report.get_report__reportId_);
  const response = (await client.apis.report.get_report__reportId_({
    reportId,
    fileId
  })).body;

  return response;
};



// WEBPACK FOOTER //
// ./src/state/project/api.js